import { jwtDecode } from 'jwt-decode';

interface JwtPayloadBase {
  exp?: number;
  [key: string]: unknown;
}

const decodeJwt = (token: string): JwtPayloadBase | null => {
  try {
    const payload = jwtDecode<JwtPayloadBase>(token);
    return payload;
  } catch {
    return null;
  }
};

const decodeAccessTokenExp = (token: string): number | null => {
  const payload = decodeJwt(token);
  return typeof payload?.exp === 'number' ? payload.exp : null;
};

export default decodeAccessTokenExp;
